import { createAsyncThunk } from '@reduxjs/toolkit';
import { IState } from '../..';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

export const deleteShipmentItems = createAsyncThunk<void, number[], { state: IState }>(
  'logistics/deleteShipmentItems',
  async (shipmentItemIds, { dispatch, getState }) => {
    dispatch(uiActionCreators.showSpinnerDialog());
    const response = await executeApiRequest(() => httpService.delete('/ShipmentItems', shipmentItemIds), false);
    dispatch(uiActionCreators.hideSpinnerDialog());

    if (response.requestFailed) {
      showFailedRequestDialogThunk(response, getState(), dispatch);
    } else {
      dispatch(logisticsActionCreators.removeItems(shipmentItemIds));
    }
  }
);
